
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <form *ngIf="!loading" [formGroup]="deployment.form">
    <div class="row alert-container-block">
      <div class="col">
        <error [error]="error"></error>
      </div>
    </div>
    <div class="row step-description-block">
      <div class="col">
        <div class="float-left">
          <p>Enter order details:</p>
        </div>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-md-10 card-block">
        <div class="row">
          <div class="col-lg-6">
            <div class="row">
              <div class="form-group col">
                <label class="required" for="deploymentName">Name:</label>
                <input class="form-control" id="deploymentName" formControlName="name">
              </div>
            </div>
            <div class="row">
              <div class="form-group col">
                <label for="sourceName">Source name:</label>
                <input class="form-control" id="sourceName" formControlName="sourceName">
              </div>
            </div>
            <div class="row">
              <div class="from-group col">
                <label for="workOrderEndSignature">Print Work Orders Signature</label>
                <div class="input-group">
                  <select class="form-control" id="workOrderEndSignature" formControlName="workOrderEndSignature">
                    <option [ngValue]="false">For each work order</option>
                    <option [ngValue]="true">One for all work orders</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row">
              <div class="form-group col">
                <div class="inline-block">
                  <label for="estimatedCompleteDate">Estimated Completion Date:
                    <help-dialog-button fieldName="Estimated Completion Date" helpString="The estimated date that all deployment deliverables will be completed for this deployment"></help-dialog-button>
                  </label>
                </div>
                <datepicker class="right input-group-append" formControlName="estimatedCompleteDate" [value]="deployment.form.value.estimatedCompleteDate" showInput="estimatedCompleteDate" [options]="completionDateOptions"></datepicker>
              </div>
            </div>
            <div class="row">
              <div class="form-group col">
                <div class="inline-block">
                  <label for="estimatedInstallationDate">Estimated Installation Date:</label>
                </div>
                <datepicker class="right input-group-append" formControlName="estimatedInstallationDate" [value]="deployment.form.value.estimatedInstallationDate" showInput="estimatedInstallationDate"></datepicker>
              </div>
            </div>
            <div class="row" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="form-group col">
                <div class="inline-block">
                  <label for="requestedInstallationDate">Requested Installation Date:</label>
                </div>
                <datepicker class="right input-group-append" formControlName="requestedInstallationDate" [value]="deployment.form.value.requestedInstallationDate" showInput="requestedInstallationDate"></datepicker>
              </div>
            </div>
            <div class="row" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="form-group col">
                <div class="inline-block">
                  <label for="estimatedSubmissionDate">Estimated Submission Date:</label>
                </div>
                <datepicker class="right input-group-append" formControlName="estimatedSubmissionDate" [value]="deployment.form.value.estimatedSubmissionDate" showInput="estimatedSubmissionDate"></datepicker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-md-10 card-block">
        <div class="row">
          <div class="form-group col" formGroupName="partnerPurchaseOrders">
            <label>Install Partner PO:</label>
            <fieldset formArrayName="items">
              <div class="form-check" *ngFor="let ppo of deployment.partnerPurchaseOrders.listItems, let i = index" [formGroupName]="i">
                <input class="form-check-input" id="installPO" type="checkbox" formControlName="selected" autoLinkToLabel>
                <label class="form-check-label">{{ ppo.name }}</label>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div class="row step-description-block">
      <div class="col">
        <div class="float-left">
          <p>Fill out Work Order Quality Checklist:</p>
        </div>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-md-10 card-block" formGroupName="qualityChecklist">
        <h5>Installation Quality Checklist</h5>
        <div class="alert alert-info" *ngIf="!!deployment.form?.controls?.qualityChecklist?.dirty">Changes to this list will only be saved when you save this step.</div>
        <filtered-list-controls [list]="deployment.qualityChecklist" [showSearch]="false" [showLimit]="true">
          <div class="btn-group">
            <button class="btn btn-outline-primary" id="copyProject" (click)="copyQualityChecklistFromProject()" type="button">Copy from Project</button>
            <button class="btn btn-outline-primary" id="addQuality" (click)="addQualityChecklistItem()" type="button"><span class="oi oi-plus"></span> Add</button>
          </div>
        </filtered-list-controls>
        <table class="table table-responsive table-sm" formArrayName="items">
          <thead>
            <tr class="no-top-border">
              <th class="w1pct"></th>
              <th>Checklist Item</th>
              <th class="w1pct"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of deployment.qualityChecklist.filtered" [formGroupName]="item.index">
              <td>
                <list-move-controls [item]="item" [list]="deployment.qualityChecklist"></list-move-controls>
              </td>
              <ng-template [ngIf]="!item.editing" [ngIfElse]="qualityChecklistItemEdit">
                <td>{{ item.name }}</td>
              </ng-template>
              <ng-template #qualityChecklistItemEdit>
                <td>
                  <input class="form-control form-control-sm" type="text" formControlName="name">
                </td>
              </ng-template>
              <td>
                <list-edit-controls [item]="item" [list]="deployment.qualityChecklist"></list-edit-controls>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row step-description-block">
      <div class="col">
        <div class="float-left">
          <p>Fill out Work Order Installation Instructions:</p>
        </div>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-md-10 card-block" formGroupName="installationInstructionsMAI">
        <h5>MAI Installation Instructions</h5>
        <div class="alert alert-info" *ngIf="!!deployment.form?.controls?.installationInstructionsMAI?.dirty">Changes to this list will only be saved when you save this step.</div>
        <filtered-list-controls [list]="deployment.installationInstructionsMAI" [showSearch]="false" [showLimit]="true">
          <div class="btn-group">
            <button class="btn btn-outline-primary" id="maiCopy" (click)="copyInstallationInstructionsMAIProject()" type="button">Copy from Project</button>
            <button class="btn btn-outline-primary" id="maiAdd" (click)="addInstallationInstructionsMAIItem()" type="button"><span class="oi oi-plus"></span> Add</button>
          </div>
        </filtered-list-controls>
        <table class="table table-responsive table-sm" formArrayName="items">
          <thead>
            <tr class="no-top-border">
              <th class="w1pct"></th>
              <th>Instruction</th>
              <th class="w1pct"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of deployment.installationInstructionsMAI.filtered" [formGroupName]="item.index">
              <td>
                <list-move-controls [item]="item" [list]="deployment.installationInstructionsMAI"></list-move-controls>
              </td>
              <ng-template [ngIf]="!item.editing" [ngIfElse]="installationInstructionsMAIEdit">
                <td>{{ item.name }}</td>
              </ng-template>
              <ng-template #installationInstructionsMAIEdit>
                <td>
                  <input class="form-control form-control-sm" type="text" formControlName="name">
                </td>
              </ng-template>
              <td>
                <list-edit-controls [item]="item" [list]="deployment.installationInstructionsMAI"></list-edit-controls>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-md-10 card-block" formGroupName="installationInstructionsLease">
        <h5>Lease Installation Instructions</h5>
        <div class="alert alert-info" *ngIf="!!deployment.form?.controls?.installationInstructionsLease?.dirty">Changes to this list will only be saved when you save this step.</div>
        <filtered-list-controls [list]="deployment.installationInstructionsLease" [showSearch]="false" [showLimit]="true">
          <div class="btn-group">
            <button class="btn btn-outline-primary" id="leaseCopy" (click)="copyInstallationInstructionsLeaseProject()" type="button">Copy from Project</button>
            <button class="btn btn-outline-primary" id="leaseAdd" (click)="addInstallationInstructionsLeaseItem()" type="button"><span class="oi oi-plus"></span> Add</button>
          </div>
        </filtered-list-controls>
        <table class="table table-responsive table-sm" formArrayName="items">
          <thead>
            <tr class="no-top-border">
              <th class="w1pct"></th>
              <th>Instruction</th>
              <th class="w1pct"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of deployment.installationInstructionsLease.filtered" [formGroupName]="item.index">
              <td>
                <list-move-controls [item]="item" [list]="deployment.installationInstructionsLease"></list-move-controls>
              </td>
              <ng-template [ngIf]="!item.editing" [ngIfElse]="installationInstructionsLeaseEdit">
                <td>{{ item.name }}</td>
              </ng-template>
              <ng-template #installationInstructionsLeaseEdit>
                <td>
                  <input class="form-control form-control-sm" type="text" formControlName="name">
                </td>
              </ng-template>
              <td>
                <list-edit-controls [item]="item" [list]="deployment.installationInstructionsLease"></list-edit-controls>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>
</div>